import clinicWelcome from 'src/assets/auth-artwork/auth-clinic-welcome.webp';
import clinicWelcomePreview from 'src/assets/auth-artwork/auth-clinic-welcome-preview.webp';
import ownerWelcome from 'src/assets/auth-artwork/auth-owner-welcome.webp';
import ownerWelcomePreview from 'src/assets/auth-artwork/auth-owner-welcome-preview.webp';
import ownerJoin from 'src/assets/auth-artwork/auth-owner-join.webp';
import ownerJoinPreview from 'src/assets/auth-artwork/auth-owner-join-preview.webp';
import accountStatus from 'src/assets/auth-artwork/auth-account-status.webp';
import accountStatusPreview from 'src/assets/auth-artwork/auth-account-status-preview.webp';
import documents from 'src/assets/auth-artwork/auth-documents.webp';
import documentsPreview from 'src/assets/auth-artwork/auth-documents-preview.webp';
import email from 'src/assets/auth-artwork/auth-email.webp';
import emailPreview from 'src/assets/auth-artwork/auth-email-preview.webp';
import password from 'src/assets/auth-artwork/auth-password.webp';
import passwordPreview from 'src/assets/auth-artwork/auth-password-preview.webp';
import phone from 'src/assets/auth-artwork/auth-phone.webp';
import phonePreview from 'src/assets/auth-artwork/auth-phone-preview.webp';
import retry from 'src/assets/auth-artwork/auth-retry.webp';
import retryPreview from 'src/assets/auth-artwork/auth-retry-preview.webp';
import verified from 'src/assets/auth-artwork/auth-verified.webp';
import verifiedPreview from 'src/assets/auth-artwork/auth-verified-preview.webp';

export interface AuthArtworkSource {
  src: string;
  previewSrc: string;
}

export const AUTH_ARTWORK = {
  clinicWelcome: { src: clinicWelcome, previewSrc: clinicWelcomePreview },
  ownerWelcome: { src: ownerWelcome, previewSrc: ownerWelcomePreview },
  ownerJoin: { src: ownerJoin, previewSrc: ownerJoinPreview },
  accountStatus: { src: accountStatus, previewSrc: accountStatusPreview },
  documents: { src: documents, previewSrc: documentsPreview },
  email: { src: email, previewSrc: emailPreview },
  password: { src: password, previewSrc: passwordPreview },
  phone: { src: phone, previewSrc: phonePreview },
  retry: { src: retry, previewSrc: retryPreview },
  verified: { src: verified, previewSrc: verifiedPreview },
} satisfies Record<string, AuthArtworkSource>;
